import { render, staticRenderFns } from "./friendsfissionData.vue?vue&type=template&id=7d4cb52f&scoped=true"
import script from "./friendsfissionData.vue?vue&type=script&lang=js"
export * from "./friendsfissionData.vue?vue&type=script&lang=js"
import style0 from "./friendsfissionData.vue?vue&type=style&index=0&id=7d4cb52f&prod&lang=less&scoped=true"
import style1 from "./friendsfissionData.vue?vue&type=style&index=1&id=7d4cb52f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4cb52f",
  null
  
)

export default component.exports